import {type MouseEventHandler} from 'react';
import {FormattedMessage} from 'react-intl';
import {type ButtonProps} from '@mui/material';
import {Edit} from 'components/icons';
import {IconButton} from 'components/buttons';

export type EditIconButtonProps = ButtonProps & {
  labelId?: string;
  onClick?: MouseEventHandler;
};

const EditIconButton = ({labelId = 'button.edit', ...props} : EditIconButtonProps) : JSX.Element => {
  return (
    <IconButton tooltip={labelId ? <FormattedMessage id={labelId} /> : ''} {...props}>
      <Edit />
    </IconButton>
  );
};

export default EditIconButton;